export enum EnvName {
  local = 'LOCAL',
  dev = 'DEV',
  test = 'TST',
  prod = 'PROD',
  none = ''
}

export interface ThemeObject {
  envName: string;
  themeColors: {}[];
}